import { render, staticRenderFns } from "./RelatedFaresList.vue?vue&type=template&id=7d45f8b2&scoped=true&"
import script from "./RelatedFaresList.vue?vue&type=script&lang=js&"
export * from "./RelatedFaresList.vue?vue&type=script&lang=js&"
import style0 from "./RelatedFaresList.vue?vue&type=style&index=0&id=7d45f8b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45f8b2",
  null
  
)

export default component.exports